import './bootstrap.js';

import { createApp } from 'vue';

import Accordion from './components/Accordion.vue';
import Button from './components/Button.vue';
import Estimate from './components/Estimate.vue';
import Foot from './components/Foot.vue';
import Heading from './components/Heading.vue';
import Icon from './components/Icon.vue';
import Logo from './components/Logo.vue';
import Navbar from './components/Navbar.vue';
import Page from './components/Page.vue';
import RentalEstimate from './components/RentalEstimate.vue';
import SiteHeader from './components/SiteHeader.vue';
import SiteFooter from './components/SiteFooter.vue';
import Snackbar from './components/Snackbar.vue';
import Screenshots from './components/Screenshots.vue';
import Quiz from './components/Quiz.vue';
import AddToCartButton from './components/AddToCartButton.vue';
import Cart from './components/Cart.vue';
import CheckoutButton from './components/CheckoutButton.vue';

const app = createApp({});

app.component('Accordion', Accordion);
app.component('Button', Button);
app.component('Estimate', Estimate);
app.component('Foot', Foot);
app.component('Heading', Heading);
app.component('Icon', Icon);
app.component('Logo', Logo);
app.component('Navbar', Navbar);
app.component('Page', Page);
app.component('rental-estimate', RentalEstimate);
app.component('site-header', SiteHeader);
app.component('site-footer', SiteFooter);
app.component('snackbar', Snackbar);
app.component('screenshots', Screenshots);
app.component('quiz', Quiz);
app.component('add-to-cart-button', AddToCartButton);
app.component('cart', Cart);
app.component('checkout-button', CheckoutButton);

app.mount('#app');
